export const US_STATE_NAMES: Record<string, string> = {
  AK: 'Alaska',
  AL: 'Alabama',
  AR: 'Arkansas',
  AZ: 'Arizona',
  CA: 'California',
  CO: 'Colorado',
  CT: 'Connecticut',
  DC: 'District of Columbia',
  DE: 'Delaware',
  FL: 'Florida',
  GA: 'Georgia',
  HI: 'Hawaii',
  IA: 'Iowa',
  ID: 'Idaho',
  IL: 'Illinois',
  IN: 'Indiana',
  KS: 'Kansas',
  KY: 'Kentucky',
  LA: 'Louisiana',
  MA: 'Massachusetts',
  MD: 'Maryland',
  ME: 'Maine',
  MI: 'Michigan',
  MN: 'Minnesota',
  MO: 'Missouri',
  MS: 'Mississippi',
  MT: 'Montana',
  NC: 'North Carolina',
  ND: 'North Dakota',
  NE: 'Nebraska',
  NH: 'New Hampshire',
  NJ: 'New Jersey',
  NM: 'New Mexico',
  NV: 'Nevada',
  NY: 'New York',
  OH: 'Ohio',
  OK: 'Oklahoma',
  OR: 'Oregon',
  PA: 'Pennsylvania',
  PR: 'Puerto Rico',
  RI: 'Rhode Island',
  SC: 'South Carolina',
  SD: 'South Dakota',
  TN: 'Tennessee',
  TX: 'Texas',
  UT: 'Utah',
  VA: 'Virginia',
  VI: 'Virgin Islands',
  VT: 'Vermont',
  WA: 'Washington',
  WI: 'Wisconsin',
  WV: 'West Virginia',
  WY: 'Wyoming',
}

export const US_STATE_OPTIONS = Object.entries(US_STATE_NAMES).map(
  ([value, label]) => ({ value, label: `${value} (${label})` })
)

export const PLAN_OVERRIDE_TAB_KEYS = {
  PLAN_BENEFITS: 'plan-benefits',
  LOCATIONS: 'locations',
  SMOKER_RATES: 'smoker-rates',
  SERVICE_AREAS: 'service-areas',
  PLANS_RATES: 'plans-rates',
} as const

export type PlanOverrideTabKey =
  (typeof PLAN_OVERRIDE_TAB_KEYS)[keyof typeof PLAN_OVERRIDE_TAB_KEYS]

export const PLAN_OVERRIDE_TABS: { key: PlanOverrideTabKey; label: string }[] =
  [
    { key: PLAN_OVERRIDE_TAB_KEYS.LOCATIONS, label: 'Locations' },
    { key: PLAN_OVERRIDE_TAB_KEYS.SMOKER_RATES, label: 'Smoker Rates' },
    { key: PLAN_OVERRIDE_TAB_KEYS.SERVICE_AREAS, label: 'Service Areas' },
    { key: PLAN_OVERRIDE_TAB_KEYS.PLANS_RATES, label: 'Plans & Rates' },
    { key: PLAN_OVERRIDE_TAB_KEYS.PLAN_BENEFITS, label: 'Plan Benefits' },
  ]

export const DEFAULT_TAB_KEY: PlanOverrideTabKey =
  PLAN_OVERRIDE_TAB_KEYS.PLAN_BENEFITS
